import { combineReducers } from 'redux';
import { BillingAction, BillingActionType } from '../../actions/billingActions';

const loadingPaymentMethod = (state = false, action: BillingAction) => {
  switch (action.type) {
    case BillingActionType.GET_CURRENT_PAYMENT_METHOD:
      return true;
    case BillingActionType.GET_CURRENT_PAYMENT_METHOD_OK:
    case BillingActionType.GET_CURRENT_PAYMENT_METHOD_ERROR:
      return false;
    default:
      return state;
  }
};

const loadingSubscription = (state = false, action: BillingAction) => {
  switch (action.type) {
    case BillingActionType.GET_CURRENT_SUBSCRIPTION:
      return true;
    case BillingActionType.GET_CURRENT_SUBSCRIPTION_OK:
    case BillingActionType.GET_CURRENT_SUBSCRIPTION_ERROR:
      return false;
    default:
      return state;
  }
};

const changingTierPlan = (state = false, action: BillingAction) => {
  switch (action.type) {
    case BillingActionType.CHANGE_SUBSCRIPTION_TIER:
      return true;
    case BillingActionType.CHANGE_SUBSCRIPTION_TIER_OK:
    case BillingActionType.CHANGE_SUBSCRIPTION_TIER_ERROR:
      return false;
    default:
      return state;
  }
};

const updatingBillingInformation = (state = false, action: BillingAction) => {
  switch (action.type) {
    case BillingActionType.UPDATE_BILLING_INFORMATION:
      return true;
    case BillingActionType.UPDATE_BILLING_INFORMATION_OK:
    case BillingActionType.UPDATE_BILLING_INFORMATION_ERROR:
      return false;
    default:
      return state;
  }
};

const deletingPaymentMethod = (state = false, action: BillingAction) => {
  switch (action.type) {
    case BillingActionType.DELETE_PAYMENT_METHOD:
      return true;
    case BillingActionType.DELETE_PAYMENT_METHOD_ERROR:
    case BillingActionType.DELETE_PAYMENT_METHOD_OK:
      return false;
    default:
      return state;
  }
};

const creatingPaymentMethod = (state = false, action: BillingAction) => {
  switch (action.type) {
    case BillingActionType.CREATE_PAYMENT_METHOD:
      return true;
    case BillingActionType.CREATE_PAYMENT_METHOD_ERROR:
    case BillingActionType.CREATE_PAYMENT_METHOD_OK:
      return false;
    default:
      return state;
  }
};

const loadingUsage = (state = false, action: BillingAction) => {
  switch (action.type) {
    case BillingActionType.GET_USAGE:
      return true;
    case BillingActionType.GET_USAGE_ERROR:
    case BillingActionType.GET_USAGE_OK:
      return false;
    default:
      return state;
  }
};

const updatingUsageLimit = (state = false, action: BillingAction) => {
  switch (action.type) {
    case BillingActionType.UPDATE_USAGE_LIMIT:
      return true;
    case BillingActionType.UPDATE_USAGE_LIMIT_ERROR:
    case BillingActionType.UPDATE_USAGE_LIMIT_OK:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  loadingPaymentMethod,
  loadingSubscription,
  changingTierPlan,
  updatingBillingInformation,
  deletingPaymentMethod,
  creatingPaymentMethod,
  loadingUsage,
  updatingUsageLimit,
});
